export const GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_LOADING =
  'GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_LOADING';
export const GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_DATA =
  'GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_DATA';
export const GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_LOADING_ERROR =
  'GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_LOADING_ERROR';
export const CLEAR_CREATE_TRANSACTION_SUMMARY_ERROR =
  'CLEAR_CREATE_TRANSACTION_SUMMARY_ERROR';
export const GET_EXISTING_TRAN_SUMMARY_PREVIEW_LOADING =
  'GET_EXISTING_TRAN_SUMMARY_PREVIEW_LOADING';
export const GET_EXISTING_TRAN_SUMMARY_PREVIEW_LOADING_ERROR =
  'GET_EXISTING_TRAN_SUMMARY_PREVIEW_LOADING_ERROR';
export const CLOSE_PERIOD_LOADING = 'CLOSE_PERIOD_LOADING';
export const CLOSE_PERIOD_LOADING_ERROR = 'CLOSE_PERIOD_LOADING_ERROR';
export const GET_OPEN_TRANSACTION_WARNING_MSG_LOADING =
  'GET_OPEN_TRANSACTION_WARNING_MSG_LOADING';
export const GET_OPEN_TRANSACTION_WARNING_MSG_LOADING_ERROR =
  'GET_OPEN_TRANSACTION_WARNING_MSG_LOADING_ERROR';
export const GET_OPEN_TRANSACTION_WARNING_MSG_DATA =
  'GET_OPEN_TRANSACTION_WARNING_MSG_DATA';
export const SHOW_WARNING_MSG = 'SHOW_WARNING_MSG';
export const CLEAR_GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_DATA =
  'CLEAR_GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_DATA';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/state/CreateTransaction/types.js